import './App.css'
import { ModelPipelineUI } from './components/ui/ModelPipelineUI'

function App() {
  return (
    <div className="min-h-screen bg-background p-8">
      <ModelPipelineUI />
    </div>
  )
}

export default App